/**
 * permissions.ts — cổng quyền cho Cơ chế lương v2, mirror
 * ../salary-rules/permissions.ts. Hai bucket quyền tách biệt:
 *   - rulev2: biểu giá theo phòng (admin/director/accounting đọc+ghi,
 *     manager chỉ đọc — theo actions.go RegisterAction).
 *   - staffoverride: điều chỉnh delta theo TỪNG nhân sự — CHỈ director
 *     (actions.go: RegisterAction("salary.staffoverride.read/write", RoleDirector)
 *     — không có admin, không có accounting, không có manager).
 */
import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

export function canReadRuleV2(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.SalaryRuleV2Read);
}

export function canWriteRuleV2(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.SalaryRuleV2Write);
}

export function canReadStaffOverride(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.SalaryStaffOverrideRead);
}

export function canWriteStaffOverride(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.SalaryStaffOverrideWrite);
}

/**
 * Sổ "một tháng chuẩn là bao nhiêu ca" (khoá cấu hình `ca_chuan_thang`).
 *
 * Gác bằng `settings.write` chứ KHÔNG bằng `salary.rulev2.write`, dù thẻ nằm
 * trên cùng trang: khoá lạ đi qua `/settings/{key}` rơi về đúng cổng đó ở máy
 * chủ — cho cả ĐỌC lẫn GHI. Lấy cổng biểu giá mà gác thì nghề kế toán (có
 * `salary.rulev2.write`, không có `settings.write`) sẽ mở ra một thẻ không tải
 * nổi sổ và bấm Lưu thì nhận 403.
 */
export function canWriteCaChuanThang(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.SettingsWrite);
}
